// extracted by mini-css-extract-plugin
export default {"content":"TzqpT","day":"_8deTh","past":"_6CjPv","dayText":"_9gmUv","today":"rfPKX","events":"_9iU8l","event":"OnfeG"};